/*
    Developer Name : Raja
    Developed Date : 20-10-2021
    Page Name      : Date Handle
    Created        :
    Last Edited By : Raja
    Edited Date    : 09.11.2021
    Last Edited    : local date to change utc
*/
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { endOfMonth, endOfWeek, endOfYear } from 'date-fns'
import * as moment from "moment";

@Injectable({
  providedIn: 'root',
})
export class DateService {


    resetBy="Daily";
  constructor(private datePipe: DatePipe) {

    this.resetBy = 'Daily'; // default always

    const branchDataRaw = localStorage.getItem('branchAccessList');
    const branchId = localStorage.getItem('branchId');

    if (!branchDataRaw || !branchId) {
      return;
    }

    try {
      const branchData = JSON.parse(branchDataRaw);

      const branch = branchData?.find(
        (e: any) => e?.id === branchId
      );

      const printerFields = branch?.printerRequiredFields;

      if (printerFields) {
        const psSetting = JSON.parse(printerFields);

        if (psSetting?.app?.['reset-by']) {
          this.resetBy = psSetting.app['reset-by'];
        }
      }

    } catch (error) {
      this.resetBy = 'Daily';
    }
  }
    


    public  dateUtctoLocalWithFormat(date,format){
        return moment.utc(date,format).local().format(format);
      }
    public dateUtctoLocal(date, format) {

        return moment.utc(date).local().format(format);
    }
    //Added for Lab Automation - abirami
    public dateUtctoLocalTime(date, format) {

        return new Date(moment.utc(date).local().format(format)).getTime();
    }

    public istDateToUtcIsoStringPreservingClockTime(istDate: Date | string): string {
      const date = new Date(istDate);
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-indexed
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
    
      // Build UTC date using IST values
      const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));
      return utcDate.toISOString();
    }
    
    public dateUtctoLocalDateAndTime(date) {

        return moment.utc(date).local().toDate();
    }

    //Return Time only **Anandh Ravichandran **Used in Appointment Nov 30 2021
    public dateUtctoLocalTimeOnly(date) {

      var test=  moment(date).format("hh:mm:ss a")
    return  moment(test, "hh:mm:ss A").format("HH:mm:ss")

      //  return moment.utc(date).local().toISOString();
    }
    public dateUtctoLocalNormalTimeOnly(date) {
      return moment(date).format("hh:mm A");
      //  return moment.utc(date).local().toISOString();
    }

    iSTtoUTC(istDateString: string): string {
      // Parse the IST date string into a Date object
      const istDate = new Date(istDateString);
      // Convert the IST date to UTC by adjusting the time zone offset
      const utcDate = new Date(istDate.getTime() - (5.5 * 60 * 60 * 1000)); // IST is UTC+5:30
      return utcDate.toISOString(); // Convert to ISO string for UTC format
    }

    public currentDate(){
        return new Date();
    }

    public newDate(date){
        return new Date(date);
    }

    // local time to change utc
    public startDate(setDate) {
        if (setDate !== null && setDate !== undefined) {
            let date: Date = new Date(this.datePipe.transform(setDate, 'mediumDate'));
            date.setMinutes(date.getMinutes() + Math.abs(date.getTimezoneOffset()));
            return date;
        }
        else {
            return null;
        }

    }
    public endDate(setDate){
        if (setDate !== null && setDate !== undefined) {
            let date: Date = new Date(this.datePipe.transform(setDate, 'mediumDate'));
            date.setHours(23);
            date.setMinutes(59 + Math.abs(date.getTimezoneOffset()));
            date.setSeconds(59);
            return date;
        }
        else {
            return null;
        }
    }


    public dateWithOffset(setDate: Date): Date | null {

        if (setDate !== null && setDate !== undefined) {

            let date: Date = new Date(this.datePipe.transform(setDate, 'mediumDate'));

            date.setMinutes(date.getMinutes() + Math.abs(date.getTimezoneOffset()));

            return date;

        }

        else {
            return null;
        }
    }




    public utcFromDate(setDate) {
        if (setDate !== null && setDate !== undefined) {
        return moment.utc(moment(this.datePipe.transform(new Date(setDate), 'yyyy-MM-dd').toString()+" 00:00:00")).format();
        }
        else {
            return null;
        }
    }
    public utcToDate(setDate){
        if (setDate !== null && setDate !== undefined) {
        return moment.utc(moment(this.datePipe.transform(new Date(setDate), 'yyyy-MM-dd').toString()+" 23:59:59")).format();
        }
        else {
            return null;
        }
    }
// OPD Sequnce Reset Date
    public opdSequcenceResetFromDate(date){
        return new Date(this.utcFromDate(date));
        // this.getDatebyReset(date, this.resetBy, 'from')
    }
    public opdSequcenceResetToDate(date){
        return new Date(this.utcToDate(date));
        // this.getDatebyReset(date, this.resetBy, 'to'))
    }
    getDatebyReset(date,period,returnData){
        var fromDate;
        var toDate;
        if (!!period) {
            switch (period) {
              case "Daily":
                fromDate = date;
                toDate = date;
                break;
              case "Weekly":
                var today = new Date(date.getFullYear(),date.getMonth(),date.getDate());
                fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
                toDate = endOfWeek(date);
                break;
              case "Monthly":
                fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
                toDate = endOfMonth(date);
                break;
              case "Yearly":
                fromDate = new Date(date.getFullYear(), 0, 1);
                toDate = endOfYear(date);
                break;
            }
            if(returnData=='from')
                return fromDate;
            else if(returnData=='to')
                return toDate;
        }
    }




    getPatientAgeByDOB(dob, ageResult, dobFlag): any {

        if (dobFlag == "Y") {
    
          var patientDob = new Date(dob);
    
          var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
          var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
          var ageValue = Difference_In_Days / 365.25;
          ageValue = Math.trunc(ageValue);
          //extract the year, month, and date from user date input  
          var dobMonth = patientDob.getMonth();
          var dobDate = patientDob.getDate();
    
          //get the current date from the system  
          var now = new Date();
          //extract the year, month, and date from current date  
          var currentMonth = now.getMonth();
          var currentDate = now.getDate();
    
          //get months  
          if (currentMonth >= dobMonth)
            //get months when current month is greater  
            var monthAge = currentMonth - dobMonth;
          else {
            // yearAge--;  
            var monthAge = 12 + currentMonth - dobMonth;
          }
    
          //get days  
          if (currentDate >= dobDate)
            //get days when the current date is greater  
            var dateAge = currentDate - dobDate;
          else {
            monthAge--;
            // Get the number of days in the previous month dynamically
            var daysInPreviousMonth = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
            var dateAge = daysInPreviousMonth + currentDate - dobDate;
    
            if (monthAge < 0) {
              monthAge = 11;
            }
          }
          // return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'
          if(ageValue==0 && monthAge == 0 && dateAge == 0){
            return "New Born"
          }else
          {
            return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'
          }
    
        } else {
    
          if (ageResult != null) {
    
            var patientAgeResult = new Date(ageResult);
    
            var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
            var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
            var ageValue = Difference_In_Days / 365.25;
            ageValue = Math.trunc(ageValue); //Get Before Decimal Value
    
            //extract the year, month, and date from user date input  
            var dobMonth = patientAgeResult.getMonth();
            var dobDate = patientAgeResult.getDate();
    
            //get the current date from the system  
            var now = new Date();
            //extract the year, month, and date from current date  
            var currentMonth = now.getMonth();
            var currentDate = now.getDate();
    
            //get months  
            if (currentMonth >= dobMonth)
              //get months when current month is greater  
              var monthAge = currentMonth - dobMonth;
            else {
              // yearAge--;  
              var monthAge = 12 + currentMonth - dobMonth;
            }
    
            //get days  
            if (currentDate >= dobDate)
              //get days when the current date is greater  
              var dateAge = currentDate - dobDate;
            else {
              monthAge--;
              // Get the number of days in the previous month dynamically
              var daysInPreviousMonth = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
              var dateAge = daysInPreviousMonth + currentDate - dobDate;
    
              if (monthAge < 0) {
                monthAge = 11;
              }
            }
            // return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'
            if(ageValue==0 && monthAge == 0 && dateAge == 0){
              return "New Born"
            }else
            {
              return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'
            }
          } else {
            return '-'
    
          }
        }
    
      }
}
